import { LookupModelSearchEvent } from "@mcleod/components";
import { getDispatchControlBoolean } from "@mcleod/general";
import { AutogenLayoutBrokerageRevenueReport } from "./autogen/AutogenLayoutBrokerageRevenueReport";

export class BrokerageRevenueReport extends AutogenLayoutBrokerageRevenueReport {
    private _steamshipsVisible = false;

    override onLoad(): void {
        this._steamshipsVisible = getDispatchControlBoolean("is_container_active", false);
        this.excludeabletextboxSteamshipLines.visible = this._steamshipsVisible;
        this.textboxIncludeContainer.visible = this._steamshipsVisible;

        this.textboxDateType.selectedItem = this.textboxDateType.items[1];
        this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
        this.textboxIncludeContainer.selectedItem = this.textboxIncludeContainer.items[0];
    }

    private textboxCustomersBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.type_of = "C";
    }

    private textboxDispatchersBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.web_user_type = "E || U";
    }

    private textboxControllingPartiesBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_active = "Y";
    }

    private textboxOrderTypesBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_active = "Y";
    }

    private textboxSteamshipLinesBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_steamship = "Y";
    }
}
